import RawEmbed from './RawEmbed';

export default RawEmbed;
